function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_31",
  "data-name": "Trac\\xE9 31",
  d: "M31.271,38.267A31.02,31.02,0,0,0,24.878,32.6l5.2-5.185A.935.935,0,0,0,28.755,26.1l-5.54,5.522a15.346,15.346,0,0,0-7.232-1.966C10.1,29.653,4.53,33.833.7,38.267a2.892,2.892,0,0,0,0,3.762A31.02,31.02,0,0,0,7.088,47.7l-5.2,5.185A.935.935,0,0,0,3.212,54.2l5.54-5.522a15.346,15.346,0,0,0,7.232,1.966c5.888,0,11.453-4.18,15.287-8.615A2.892,2.892,0,0,0,31.271,38.267ZM2.115,40.81a1,1,0,0,1,0-1.323c2.071-2.4,7.568-7.966,13.868-7.966a13.248,13.248,0,0,1,5.84,1.486l-2.569,2.561a5.629,5.629,0,0,0-7.866,7.841L8.446,46.342A29.278,29.278,0,0,1,2.115,40.81Zm17.637-.662a3.769,3.769,0,0,1-5.686,3.232l2.58-2.572,2.58-2.572a3.723,3.723,0,0,1,.526,1.912Zm-7.538,0A3.768,3.768,0,0,1,17.9,36.916l-2.58,2.572-2.58,2.572a3.724,3.724,0,0,1-.526-1.912Zm17.637.662c-2.071,2.4-7.568,7.966-13.868,7.966a13.248,13.248,0,0,1-5.84-1.486l2.569-2.561a5.629,5.629,0,0,0,7.866-7.841l2.942-2.933a29.28,29.28,0,0,1,6.331,5.531A1,1,0,0,1,29.852,40.81Z",
  transform: "translate(0 -25.823)",
  fill: "#007cc0"
});

var SvgIcEyeClosed = function SvgIcEyeClosed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "restriction",
    width: 31.966,
    height: 28.652,
    viewBox: "0 0 31.966 28.652",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcEyeClosed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_eye_closed.9a25f4c6.svg";
export { ForwardRef as ReactComponent };